// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryTitle-module--title--Yhovx"};